import Link from 'next/link';

import { LegalDoc } from '../legal.types';
import { ContentHeadline, ContentPanel } from 'shared/styles/components';
import { LegalPostContent, LegalTitleMeta } from './legal-post.styles';

type LegalPostProps = {
  document: LegalDoc;
  children: React.ReactNode;
};

export default function LegalPost({ document, children }: LegalPostProps) {
  return (
    <>
      <ContentPanel>
        <ContentHeadline>
          <Link className="crumb" href="/legal">
            Legal
          </Link>
          <h1>{document.title}</h1>
          <LegalTitleMeta>
            <span>Last Modified: {document.currentAsOf}</span>
          </LegalTitleMeta>
        </ContentHeadline>
      </ContentPanel>
      <ContentPanel>
        <LegalPostContent>{children}</LegalPostContent>
      </ContentPanel>
    </>
  );
}
